import { Injectable } from '@angular/core';
interface Question {
  parameters: { INPUT_TEXT: string; [key: string]: any };
  [key: string]: any;
}
interface Answer {
  text: string;
  [key: string]: any;
}
interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
}


@Injectable({
  providedIn: 'root'
})
export class CopilotHelperServiceService {

  constructor() { }

  convertQuestionAndAnswersToConversations(conversation: {questions: any[], answers: any[]}){
    const chat: ChatMessage[] = [];
    const questions = conversation.questions;
    const answers = conversation.answers;
    const len = Math.min(questions.length, answers.length);
    for (let i = 0; i < len; i++) {
      chat.push({
        role: 'user',
        content: questions[i].parameters.INPUT_TEXT ?? '',
      });
      chat.push({
        role: 'assistant',
        content: answers[i].text ?? '',
      });
    }
    return chat;
  }

  splitConversations(
    chat: ChatMessage[]
  ): { questions: Question[]; answers: Answer[] } {
    const questions: Question[] = [];
    const answers: Answer[] = [];

    for (const msg of chat) {
      if (msg.role === 'user') {
        questions.push({ parameters: { INPUT_TEXT: msg.content }, type: "Question",  });
      } else {
        answers.push({ text: msg.content, isLoading: false, type: "simple", tableData: null });
      }
    }

    return { questions, answers };
  }
}